import { parseAsInteger, parseAsStringEnum, useQueryState } from 'nuqs';

export type Direction = 'descending' | 'ascending';

export const usePagination = () => {
  const [direction, setDirection] = useQueryState(
    'direction',
    parseAsStringEnum<Direction>(['descending', 'ascending']).withDefault('descending')
  );
  const [pageIndex, setPageIndex] = useQueryState('pageIndex', parseAsInteger.withDefault(1));
  const [pageSize, setPageSize] = useQueryState('pageSize', parseAsInteger.withDefault(50));

  return {
    setDirection,
    setPageIndex,
    setPageSize,
    direction,
    pageIndex,
    pageSize,
  };
};
